// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"163":"MobileAppPage","383":"SalePage"}[chunkId] || chunkId) + "." + {"149":"2103bff6","163":"4c4189f9","383":"e4d34a2d"}[chunkId] + ".js";
};